import { render, staticRenderFns } from "./QuestionsTable.vue?vue&type=template&id=86342440&scoped=true&"
import script from "./QuestionsTable.vue?vue&type=script&lang=js&"
export * from "./QuestionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86342440",
  null
  
)

export default component.exports